import "./styles.css";
import 'bootstrap/dist/css/bootstrap.css';
import React, { useState } from "react";
import Forecast from "./Forecast";
import Weather from "./Weather";

export default function App() {
  const [unit, setUnit] = useState("celsius");

  const changeUnit = () => {
    setUnit((prevUnit) => (prevUnit === "celsius" ? "fahrenheit" : "celsius"));
  };

  return (
    <div className="App weather-app">
      <div className="current-city">
        <Weather defaultCity="Sao Paulo" unit={unit} changeUnit={changeUnit} />
      </div>
      <Forecast unit={unit} changeUnit={changeUnit} />
      <footer>
        This project was coded with 🤍by <a href="https://www.linkedin.com/in/karine-magalhaes-heidgerken-3836911a7/" target="_blank" rel="noopener noreferrer">Karine Magalhaes</a> and is open sourced on <a href="https://github.com/Kamagalhaes92/react-app" target="_blank" rel="noopener noreferrer">GitHub</a> 
      </footer>
    </div>
  );
}